import { render, staticRenderFns } from "./ModalComponentPage.vue?vue&type=template&id=3af3c508"
import script from "./ModalComponentPage.vue?vue&type=script&lang=js"
export * from "./ModalComponentPage.vue?vue&type=script&lang=js"
import style0 from "./ModalComponentPage.vue?vue&type=style&index=0&id=3af3c508&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af3c508')) {
      api.createRecord('3af3c508', component.options)
    } else {
      api.reload('3af3c508', component.options)
    }
    module.hot.accept("./ModalComponentPage.vue?vue&type=template&id=3af3c508", function () {
      api.rerender('3af3c508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalComponentPage.vue"
export default component.exports